import React, { useEffect, useState } from 'react';
import { Modal, Button, Text, Group, Stack, Image, Box, useMantineTheme } from '@mantine/core';
import { GITCOIN_CAMPAIGN_URL } from '../config';
import { auraEffect } from '../styles/animations';
import { CountdownSimple } from './CountdownSimple';
import { useMediaQuery } from '@mantine/hooks';

const GITCOIN_POPUP_SHOWN_KEY = 'gitcoin_popup_shown';

interface GitCoinPopupProps {
  onClose?: () => void;
}

export const GitCoinPopup: React.FC<GitCoinPopupProps> = ({ onClose }) => {
  const [opened, setOpened] = useState(false);
  const theme = useMantineTheme();
  const isXsScreen = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  useEffect(() => {
    const hasBeenShown = localStorage.getItem(GITCOIN_POPUP_SHOWN_KEY);

    if (!hasBeenShown && GITCOIN_CAMPAIGN_URL) {
      const timer = setTimeout(() => {
        setOpened(true);
      }, 27000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    // Mark as shown in localStorage
    localStorage.setItem(GITCOIN_POPUP_SHOWN_KEY, 'true');
    setOpened(false);
    if (onClose) onClose();
  };

  const handleSupport = () => {
    if (GITCOIN_CAMPAIGN_URL) {
      window.open(GITCOIN_CAMPAIGN_URL, '_blank');
    }
    handleClose();
  };

  if (!GITCOIN_CAMPAIGN_URL) return null;

  return (
    <Modal opened={opened} onClose={handleClose} title="" centered size="lg">
      <Stack gap="0" maw="320px" mx="auto">
        <Text
          fw={300}
          size={isXsScreen ? '24px' : '30px'}
          ml={isXsScreen ? '170px' : '213px'}
          c="white"
          className={auraEffect}
        >
          Live on
        </Text>
        <Group mt={isXsScreen ? '-18px' : '-23px'}>
          <Image src="https://www.rankify.it/logo.png" alt="Rankify Logo" w={isXsScreen ? '180' : '225'} py="md" />
        </Group>
        <Box ml={isXsScreen ? '200px' : '250px'} mt={isXsScreen ? '-59px' : '-60px'}>
          <svg fill="none" viewBox="0 0 27 32" width={isXsScreen ? '45px' : '56px'} xmlns="http://www.w3.org/2000/svg">
            <path
              d="m25.8683 17.7777c0 1.7733-.4008 3.4528-1.1172 4.9544l-1.5588-.9711-.7304-.455c.47-1.0816.7304-2.275.7304-3.5283s-.2604-2.4467-.7304-3.5283l.7304-.455 1.5588-.9712c.7164 1.5017 1.1172 3.1812 1.1172 4.9545z"
              fill="#ffffff"
            ></path>
            <path
              d="m23.1926 21.7611-.7304-.455-2.8015-1.7444c-.1633-.1017-.243-.2973-.1962-.4834.1042-.4161.16-.8516.16-1.3 0-.4483-.0552-.8839-.16-1.3-.0468-.1866.0329-.3816.1962-.4833l2.8015-1.7444 2.2892-1.4262 1.5716-.9788c.4064-.2534.5419-.7828.3011-1.1962-.0803-.1383-.1634-.2744-.2481-.4094-.2375-.37778-.4923-.74389-.7633-1.09667-2.5662-3.34166-6.587-5.51611-11.1195-5.585-.1227-.00166-.2214-.1-.2214-.22222v-2.00278c0-.736108-.5993-1.33333-1.338-1.33333s-1.338.597222-1.338 1.33333v2.29056c0 .10611-.0753.19667-.1796.21778-.7548.15277-1.48851.365-2.19488.63166-.14551.055-.30161-.05222-.30161-.20777v-2.93223c0-.736108-.59932-1.33333-1.33803-1.33333-.7387 0-1.33803.597222-1.33803 1.33333v4.45223c0 .14555-.07247.28111-.19178.365-3.64836 2.56611-6.0356235 6.79444-6.05179138 11.57884-.02620302 7.8489 6.50115138 14.2706 14.37772138 14.2706h10.5988c.4929 0 .892-.3978.892-.8889v-7.0672c0-.3833-.1979-.7395-.524-.9422l-.5932-.3695zm-.446 7.5722h-8.3711c-6.3846 0-11.70494-5.205-11.69881-11.5666.00279-3.1767 1.29232-6.0528 3.37685-8.14003.07025-.07056.19123-.02111.19123.07833v1.4061c0 .7361.59932 1.3333 1.33803 1.3333.7387 0 1.33803-.5972 1.33803-1.3333v-3.31277c0-.16944.097-.325.24976-.39944 1.53981-.75333 3.27151-1.17667 5.10231-1.17667 3.4778 0 6.5982 1.52556 8.7234 3.94168.1812.2061.1338.525-.0992.6705l-1.8543 1.155-2.5333 1.5778c-.3139.1956-.7159.1767-1.0114-.0455-.9037-.6817-2.0315-1.0834-3.2542-1.0767-2.8996.0156-5.28015 2.3644-5.32252 5.2539-.04348 2.9817 2.36942 5.4128 5.35152 5.4128 1.2137 0 2.3327-.4023 3.2303-1.0811.2932-.2217.6941-.2362 1.0063-.0417l2.5333 1.5778 1.8883 1.1761c.1628.1016.262.2794.262.4711v3.6755c0 .2456-.1996.4445-.446.4445zm-5.7998-11.6489v.1867c-.0168.4839-.1628.935-.4048 1.32-.2481.3956-.5982.7217-1.013.9417-.3746.1989-.8022.3116-1.2566.3116-1.478 0-2.6761-1.1938-2.6761-2.6666s1.1981-2.6667 2.6761-2.6667c.4544 0 .882.1128 1.2566.3117.4148.22.7649.5461 1.013.9416.242.385.388.8362.4048 1.32z"
              fill="#ffffff"
            ></path>
          </svg>
        </Box>

        <Text
          fw={400}
          size="33px"
          ml={isXsScreen ? '140px' : '215px'}
          mt={isXsScreen ? '0' : '10px'}
          c="white"
          className={auraEffect}
        >
          GitCoin
        </Text>
      </Stack>

      <Stack align="center" mt="2.5rem">
        <Text size="lg" c="" ta="center" className={auraEffect} mb="2rem">
          Your contribution helps us develop new features and improve the platform for everyone.
        </Text>

        <CountdownSimple startTimeInSeconds={1744384096} timeToRunFromStart={60 * 60 * 24 * 6} size="2.5rem" />

        <Text fw={400} size="sm" c="dimmed" mt="-md">
          *Time till end of campaign
        </Text>

        <Group justify="center" mt="md" mb="xl">
          <Button variant="filled" size="xl" color="teal" onClick={handleSupport}>
            Support Us Now
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default GitCoinPopup;
